import Vue from 'vue';
import { cloneDeep } from 'lodash';

const CONFIRM_MODAL_FIELDS = {
  text: null,
  yesButton: 'Ok',
  noButton: 'Cancel',
  title: 'Are you sure?',
  yesCallback: null,
  noCallback: null,
};

export default {
  state: {
    ...cloneDeep(CONFIRM_MODAL_FIELDS),
    isShown: false,
  },
  mutations: {
    SET_CONFIRM_MODAL(state, payload) {
      Object.keys(payload).forEach((key) => {
        if (Object.keys(CONFIRM_MODAL_FIELDS).includes(key)) {
          state[key] = payload[key];
        }
      });
    },
    TOGGLE_CONFIRM_MODAL(state, value) {
      state.isShown = value !== undefined ? !!value : !state.isShown;
    },
    RESET_CONFIRM_MODAL(state) {
      Object.keys(CONFIRM_MODAL_FIELDS).forEach((key) => {
        state[key] = CONFIRM_MODAL_FIELDS[key];
      });
    },
  },
  actions: {
    async showConfirmModal({ commit }, payload) {
      commit('SET_CONFIRM_MODAL', payload);
      await Vue.nextTick();
      commit('TOGGLE_CONFIRM_MODAL', true);
    },
    async hideConfirmModal({ state, commit }, isConfirmed) {
      if (isConfirmed && state.yesCallback) await state.yesCallback();
      if (!isConfirmed && state.noCallback) await state.noCallback();
      commit('TOGGLE_CONFIRM_MODAL', false);
      await Vue.nextTick();
      commit('RESET_CONFIRM_MODAL', false);
    },
  },
};
